import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import ComboBox from '../ComboBox';

// Change DialogButton to the appropriate name
export class MarketComboBox extends BaseComponent {
  constructor(props) {
    super(props);

    this.createMarketOptions = this.createMarketOptions.bind(this);

    let currentMenuOption; 
    let option = props.currentOption;
    
    if(option){
      if(option.length > 1){
        currentMenuOption = {
          type: '-1',
          name: this.textMap.multipleSelected,
        };
      }
      else if (option.length == 1) {
        currentMenuOption = {
          type: option[0].id,
          name: `${option[0].code} | ${option[0].name}`,
          selected: true,
        };
      }
      else if (option.length == undefined && option.id) {
        currentMenuOption = {
          type: option.id,
          name: `${option.code} | ${option.name}`,
          selected: true,
        };
      }
    }
    if(props.selectDefault && !currentMenuOption && props.markets){
      currentMenuOption = {
        type: props.markets[0].id,
        name: `${props.markets[0].code} | ${props.markets[0].name}`,
        selected: true,
      };
    }
    this.state = {
      marketList: [],
      selectedOption: currentMenuOption,
    };
  }

  componentDidMount(){
    if(this.props.selectDefault){

      let selectedOption = { name: `${this.props.markets[0].name} | ${this.props.markets[0].name}`,  selected: true, type: this.props.markets[0].id };
      selectedOption.market = {
        code: this.props.markets[0].code,
        id: this.props.markets[0].id,
        name: this.props.markets[0].name,
        selected: false,
        toBeAdded: true,
        toBeDeleted: true,
      };
      
      this.handleMultipleSelection([selectedOption], selectedOption);
    }
  }
  
  componentDidUpdate(prevProps){
    if (prevProps.currentOption != this.props.currentOption) {
      if(this.props.currentOption){
        let currentMenuOption;
        if(this.props.currentOption.length > 1){
          currentMenuOption = { type: '-1', name: this.textMap.multipleSelected };
        }
        else if(this.props.currentOption.length == 1){
          let option = this.props.currentOption[0];
          currentMenuOption = { type: option.id, name: `${option.name}`, selected: true };
        }
        else{
          currentMenuOption = { code: this.props.currentOption.code, type: this.props.currentOption.id, name: this.props.currentOption.name };
        }
        this.setState({ selectedOption: currentMenuOption });
      }
    }
  }

  createMarketOptions() {
    const markets = this.props.markets;
    let withSelectedMarkets =  markets ? markets.map(market => {
      let selected = false;
      if (this.props.currentOption) {
        if (this.props.currentOption.length) {
          this.props.currentOption.forEach(opt => {
            if (market.id == opt.id || market.id == opt.type) {
              selected = true;
            }
          });
        }
        else {
          selected = market.id == this.props.currentOption.id || market.id == this.props.currentOption.type;
        }
      }
      market.selected = selected;
      return market;
    }) : [];
    let marketList = withSelectedMarkets ? withSelectedMarkets.map((market) => {
      return { type: market.id, name: `${market.code} | ${market.name}`, market: market, selected: market.selected };
    }) : [];
    return marketList;
  }

  handleMultipleSelection(multipleSelections, selectedOption) {
    const selectedMarket = selectedOption.market;
    if (selectedMarket) {
      let markets = multipleSelections;
      if (selectedOption.selected) {
        const findMarket = markets && markets.length ? markets.filter(market => {
          return market.id == selectedMarket.id;
        }) : [];
        if (findMarket.length == 0) {
          if (!markets.tempMarkets) {
            markets.tempMarkets = [];
          }
          selectedMarket.toBeAdded = true;
          markets.tempMarkets.push(selectedMarket);
        }
        else {
          delete selectedMarket.toBeDeleted;
        }
      }
      else {
        let removeIndex = -1;
        const findMarket = markets.tempMarkets ? markets.tempMarkets.filter((market, index) => {
          if (market.uid == market.id && market.toBeAdded) {
            removeIndex = index;
          }
          return market.id == market.id && market.toBeAdded;
        }) : [];
        if (findMarket.length > 0 && findMarket[0].toBeAdded) {
          markets.tempMarkets.splice(removeIndex, 1);
        }
        else {
          selectedMarket.toBeDeleted = true;
        }
      }
      if (this.props.handleSelectMarket) {
        this.props.handleSelectMarket(markets);
      }
      this.setState({ markets: markets });
    }
  }

  handleMenuSelection(option) {
    if (this.props.handleMenuSelection) {
      const market = this.props.markets.filter(m => {
        return m.id == parseInt(option, 10);
      });
      if (market.length > 0) {
        this.props.handleMenuSelection(market[0]);
      }
    }
  }

  render() {
    let { height, width, hasBorder, defaultText, displayFontStyle, maxHeight, top, left, label, tabIndex,
      makeAbsolute, underlined, menuHeight, multiSelect } = this.props;
    let { selectedOption } = this.state;

    height = this.props.height ? this.props.height : null;
    width = this.props.width ? this.props.width : null;
    hasBorder = this.props.hasBorder ? this.props.hasBorder : null;
    defaultText = this.props.defaultText ? this.props.defaultText : null;
    displayFontStyle = this.props.displayFontStyle ? this.props.displayFontStyle : null;
    maxHeight = this.props.maxHeight ? this.props.maxHeight : null;
    top = this.props.top ? this.props.top : null;
    left = this.props.left ? this.props.left : null;
    makeAbsolute = this.props.makeAbsolute ? this.props.makeAbsolute : null;
    label = this.props.label ? this.props.label : null;
    tabIndex = this.props.tabIndex ? this.props.tabIndex : null;
    underlined = this.props.underlined ? this.props.underlined : null;
    menuHeight = this.props.menuHeight ? this.props.menuHeight : null;

    let options = this.createMarketOptions();

    return (
      // Replace with the appropriate HTML
      <ComboBox
        id={'marketPicker'}
        options={options}
        height={height}
        width={width}
        hasBorder={hasBorder}
        backgroundIndex={this.props.backgroundIndex}
        defaultText={defaultText}
        currentOption={selectedOption}
        displayFontStyle={displayFontStyle}
        handleMultiMenuSelection={this.handleMultipleSelection}
        maxHeight={maxHeight}
        top={top}
        left={left}
        makeAbsolute={makeAbsolute}
        label={label}
        underlined={underlined}
        tabIndex={tabIndex}
        menuHeight={menuHeight}
        multiSelect={multiSelect}
        handleSelection={this.handleMenuSelection}
        dontSortMenu={true}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    permissions: state.new_users.permissions,
  };
};

export default connect(mapStateToProps)(MarketComboBox);



// WEBPACK FOOTER //
// ./src/components/MarketComboBox/index.js